module.exports = __webpack_public_path__ + "img/logo.d7584e33.png";